export const KEYS = {
  toastsSaleCartMaxReachead: 'toasts.sale.cartMaximumReached',
};
